import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
// import { CompleterService } from 'ng2-completer';

import { DefaultEditor } from './default-editor';

@Component({
  selector: 'completer-editor',
  template: `
  <ng-select [(ngModel)]="completerStr"
  [formControl]="formControl"
        [items]="cell.getColumn().getConfig().completer.dataService"
        [minTermLength]="cell.getColumn().getConfig().completer.minSearchLength || 0"
        [typeahead]="cell.getColumn().getConfig().completer.pause || 0"
        [placeholder]="cell.getColumn().getConfig().completer.placeholder || 'Start typing...'"
        (change)="onEditedCompleter($event)">
  </ng-select>
    `,
  standalone: false
})
export class CompleterEditorComponent extends DefaultEditor implements OnInit {

  get formControl(): FormControl {
    return this.cell.getValidator() as FormControl;
  }

  public completerStr: string = '';

  // constructor(private completerService: CompleterService) {
  //   super();
  // }

  public ngOnInit() {
    // No completerService logic needed. ng-select uses config.dataService directly.
  }

  public onEditedCompleter(event: { title: '' }): boolean {
    this.cell.newValue = event.title;
    return false;
  }
}